import { PageId } from 'constants/pages'

export const enum PageIdWoofzEaster80 {
  SUBSCRIPTIONS_EASTER_80 = PageId.SUBSCRIPTIONS_EASTER_80,
  CHAT_UPSELL_EASTER_80 = PageId.CHAT_UPSELL_EASTER_80,
  UPSELL_EASTER_80 = PageId.UPSELL_EASTER_80,
  DOWNLOAD_EASTER_80 = PageId.DOWNLOAD_EASTER_80,
  ACCOUNT_NOVE8 = PageId.ACCOUNT_NOVE8,
}
